<template lang="html">
   <div class="tran_by_date">
      <div class="row justify-content-center">
         <div class="col-12 col-md-7 col-lg-9 col-xl-8">
            <Form 
               classBinding="row" 
               :ref="PromoCode.forms.query_promo_codes.name" 
               :forms="PromoCode.forms.query_promo_codes.forms" 
               :form_data="PromoCode.forms.query_promo_codes.data"
            />
         </div>
         <div class="col-12 col-md-5 col-lg-3 col-xl-4">
            <div class="btn btn-primary btn-padded" :disabled="loading" @click="queryPromocodeRedemption({ref: $refs[PromoCode.forms.query_promo_codes.name]})">
               Query
               <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
            </div>
         </div>
      </div>

      <Table 
         :icon="PromoCode.tables.promocodes.icon" 
         :table_fields="PromoCode.tables.promocodes.table_fields" 
         :table_data="promocodes" 
         :title="PromoCode.tables.promocodes.title" 
         :search_fields="PromoCode.tables.promocodes.search_fields"
         :row_data="PromoCode.tables.promocodes.row_data"
         @on-action="handleActions"
      />

      <div class="row justify-content-end" v-if="promocodes.length > 0">
         <div class="col-12 col-md-4 col-lg-3">
            <div class="btn btn-long btn-primary mt-3" @click="downloadExcel()">Download Report</div>
         </div>
      </div>
   </div>
</template>

<script>
import promocode from "../rsc/stores/reports/promoCodes.store";
const XLSX = require('xlsx')

export default {
   beforeDestroy () {
      this.$store.unregisterModule('promocode')
   },
   created(){
      EventBus.$emit('loader:show',true)
      utils.registerModule('promocode',promocode,this.$store)

      setTimeout(() => {
         EventBus.$emit('actions:register',{
            title: '',
            actions: []
         })
      },200);
   },
   components:{
      Modal: () => import("@/libs/clarks/components/modal"),
      Form: () => import("@/libs/clarks/components/form"),
      Table: () => import("@/libs/clarks/components/table/table"),
   },
   computed: {
      ...mapGetters([
         'PromoCode',
         'promocodes',
         'show',
         'loading',
      ])
   },
   methods: {
      ...mapActions([
         'submitForm',
         'queryPromocodeRedemption',
      ]),
      downloadExcel(){
         try{
            var workSheet = XLSX.utils.json_to_sheet(this.promocodes);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, workSheet, 'promocodes');
            XLSX.writeFile(wb, 'promocodes.xlsx')
         }catch(err){
            console.log(err)
         }
      },
      async handleActions(payload){
         
      }
   },
   async mounted(){
      utils.registerModule('promocode',promocode,this.$store)
      EventBus.$emit('loader:show', false)
   }
}
</script>

<style lang="scss">
   .tran_by_date{
      .form-label{
         width: 100%;
      }
   }
</style>